import { Auth } from "./auth.js";
import { loadStoredSalesData } from "./orders_data.js";
import { Dashboard } from "./dashboard.js";
import { initAlibabaSync, onSyncComplete, syncForOverview, syncForProject } from "./alibaba_sync.js";
import { initChat } from "./chat.js";
import { initUserManagement, loadUserList } from "./user_mgmt.js";
import { initProductCenter, loadProducts, loadCategoryFilter, loadCategoryManagement, updateAllProductRateDisplays } from "./product_center.js";
import { loadPurchasePlans } from "./purchase_plans.js";
import { initCRM } from "./crm.js";
import { loadOrganizationData } from "./organization.js";
import { loadPerformanceDashboard } from "./performance.js";
import { loadProductMappings } from "./product_mapping.js";
import { initInvoiceCenter, openInvoiceBuilder, renderInvoiceForm, updateTopBarRate, refreshAllIsLists, refreshHeaderSelect, refreshIsDropdowns, refreshIsRate, refreshPaymentSelect } from "./invoice.js";

import "./tool_nav.js";
// Bridge: autoSavePurchaseNotes for onblur inline handler (bundle scope)
import { loadPurchasePlans as _ppLoad } from "./purchase_plans.js";
var _autoSavePurchaseNotes = null;
window.autoSavePurchaseNotes = function(textarea) {
  if (!_autoSavePurchaseNotes) {
    // The function is in purchase_plans.js but not exported; we define it here
    var planId = textarea.getAttribute("data-plan-id");
    var notes = textarea.value;
    var plan = (window._purchasePlans || []).find(function(p) { return p.id === planId; });
    if (plan) { plan.notes = notes; }
    // Also persist via fetch
    var token = (typeof Auth !== "undefined" && Auth.getToken) ? Auth.getToken() : "";
    fetch("/api/purchase-plans/" + encodeURIComponent(planId) + "/notes", {
      method: "PUT",
      headers: { "Content-Type": "application/json", "Authorization": "Bearer " + token },
      body: JSON.stringify({ notes: notes })
    }).catch(function() {});
  }
};

// Auth guard
if (!Auth.requireAuth()) {
  document.body.innerHTML = "";
  throw new Error("Not authenticated");
}

(function() { var u = Auth.getUser(); if (u) { var r = document.getElementById("sidebar-user-role"); var n = document.getElementById("sidebar-user-name"); if (r) r.textContent = u.title || u.role; if (n) n.textContent = u.displayName; } })();

/**
 * Efast Workbench - 核心入口 (导航 + 视图管理 + 全局初始化)
 * 从 sales_logic.js 拆分
 */


// ===== 视图模板预加载 =====
var _viewTemplateCache = {};

// Load a single view template (lazy, with cache)
function loadViewTemplate(viewId, callback) {
  if (_viewTemplateCache[viewId]) {
    var container = document.getElementById(viewId);
    if (container) container.innerHTML = _viewTemplateCache[viewId];
    if (callback) callback();
    return;
  }
  var templateName = viewId.replace('view-', '') + '.html';
  var done = false;
  var timer = setTimeout(function() {
    if (!done) { done = true; if (callback) callback(); }
  }, 3000);
  fetch('templates/' + templateName)
    .then(function(r) {
      if (!r.ok) throw new Error('template 404: ' + templateName);
      return r.text();
    })
    .then(function(html) {
      _viewTemplateCache[viewId] = html;
      var container = document.getElementById(viewId);
      if (container) container.innerHTML = html;
    })
    .catch(function(e) {
      // 无模板文件时静默跳过（容器由视图自身 JS 渲染），仅保留 debug 日志
      if (e && e.message && e.message.indexOf('404') >= 0) {
        if (window._errlogTemplateDebug !== false) console.debug('No template for', viewId, '— using JS render');
      } else {
        console.error('Template load failed:', templateName, e);
      }
    })
    .finally(function() {
      if (!done) { done = true; clearTimeout(timer); if (callback) callback(); }
    });
}

// Preload only the default view on init (others lazy-load on navigation)
function preloadAllTemplates(callback) {
  var saved = sessionStorage.getItem('efast_active_view') || 'view-order-overview';
  var loaded = 0;
  var total = (saved === 'view-order-overview') ? 1 : 2;
  function done() { loaded++; if (loaded >= total && callback) callback(); }
  loadViewTemplate('view-order-overview', done);
  if (saved !== 'view-order-overview') {
    loadViewTemplate(saved, done);
  }
}

document.addEventListener("DOMContentLoaded", () => {
    console.log("[INIT] DOMContentLoaded fired");
    initNavigation();
    console.log("[INIT] initNavigation done");

    // Check if any view is active
    var av = document.querySelector('.view-section.active');
    console.log("[INIT] activeView:", av ? av.id : "NONE");

    // Check sessionStorage
    console.log("[INIT] sessionStorage view:", sessionStorage.getItem('efast_active_view'));


    preloadAllTemplates(function() {
        console.log("[INIT] preloadAllTemplates callback");
        loadStoredSalesData().catch(function(e) { console.error('loadStoredSalesData 异常:', e); });
        updateTopBarRate();
        initAlibabaSync();
        initChat();
        initUserManagement();
        initProductCenter();
        if (typeof initInvoiceCenter === 'function') initInvoiceCenter();
        loadActiveViewData();
    });
});

function loadActiveViewData() {
    const activeView = document.querySelector('.view-section.active');
    if (!activeView) return;
    const id = activeView.id;

    if (id === 'view-order-overview') {
        setTimeout(function() {
            if (typeof loadStoredSalesData === 'function') loadStoredSalesData();
        }, 0);
    } else if (id === 'view-self-order') {
        if (typeof initSelfOrderForm === 'function') initSelfOrderForm();
    } else if (id === 'view-invoice-builder' && typeof renderInvoiceForm === 'function') {
        renderInvoiceForm();
    } else if (id === 'view-user-management' && Auth.getRole() === 'boss') {
        if (typeof loadUserList === 'function') loadUserList();
    } else if (id === 'view-product-center') {
        if (typeof loadProducts === 'function') loadProducts();
    } else if (id === 'view-customer-crm') {
        if (typeof initCRM === 'function') initCRM();
    } else if (id === 'view-purchase-plan') {
        if (typeof loadPurchasePlans === 'function') loadPurchasePlans();
    } else if (id === 'view-category-management') {
        if (typeof loadCategoryManagement === 'function') loadCategoryManagement();
    } else if (id === 'view-organization' && Auth.getRole() === 'boss') {
        if (typeof loadOrganizationData === 'function') loadOrganizationData();
    }
    else if (id === 'view-performance') { if (typeof loadPerformanceDashboard === 'function') loadPerformanceDashboard(); }
    else if (id === 'view-dashboard') {
        if (typeof Dashboard !== 'undefined') Dashboard.init();
    }
    else if (id === 'view-tool-nav') {
        if (window.ToolNav && typeof window.ToolNav.init === 'function') window.ToolNav.init();
    }
    else if (id === 'view-system-settings') {
        if (typeof loadCategoryFilter === 'function') loadCategoryFilter();
        setupSettingsLazyLoad(activeView);
    }
    else if (id === 'view-error-logs' && Auth.getRole() === 'boss') {
        if (typeof loadErrorLogs === 'function') loadErrorLogs();
    }
}
/**
 * IntersectionObserver lazy-load for system settings
 */
function setupSettingsLazyLoad(container) {
    var sections = container.querySelectorAll('.settings-section');
    if (!sections.length) return;
    var initFns = [
        function() { if (typeof refreshHeaderSelect === 'function') refreshHeaderSelect(); if (typeof refreshIsDropdowns === 'function') refreshIsDropdowns(); },
        function() { if (typeof refreshPaymentSelect === 'function') refreshPaymentSelect(); },
        function() { if (typeof refreshIsRate === 'function') refreshIsRate(); },
        function() { if (typeof loadCategoryManagement === 'function') loadCategoryManagement(); },
        function() { if (typeof loadProductMappings === 'function') loadProductMappings(); },
        function() { if (typeof refreshAllIsLists === 'function') refreshAllIsLists(); },
        function() { if (typeof loadAiApiSettings === 'function') loadAiApiSettings();
    if (typeof loadKBIndexStatus === 'function') loadKBIndexStatus();
    if (typeof loadKBIndexStatus === 'function') loadKBIndexStatus(); }
    ];
    var observer = new IntersectionObserver(function(entries, obs) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting) {
                var idx = parseInt(entry.target.getAttribute('data-lazy-idx'));
                if (!isNaN(idx) && idx < initFns.length) initFns[idx]();
                obs.unobserve(entry.target);
            }
        });
    }, { rootMargin: '150px' });
    sections.forEach(function(sec, i) {
        sec.setAttribute('data-lazy-idx', i);
        observer.observe(sec);
    });
    if (typeof loadAiApiSettings === 'function') loadAiApiSettings();
}
/**
 * ==========================================
 */

function initNavigation() {
    const navItems = document.querySelectorAll(".nav-menu .nav-item");
    const views = document.querySelectorAll(".view-section");

    // 初始化：如果还没任何视图是 active（内联脚本可能因 sessionStorage 为空而未设），则默认激活订单总览
    var hasActive = false;
    views.forEach(function (v) { if (v.classList.contains('active')) hasActive = true; });
    if (!hasActive) {
        var savedView = sessionStorage.getItem('efast_active_view');
        var defaultTarget = savedView || 'view-order-overview';
        var defaultNav = document.querySelector('.nav-menu .nav-item[data-target="' + defaultTarget + '"]');
        var defaultView = document.getElementById(defaultTarget);
        if (!defaultNav || !defaultView) {
            defaultTarget = 'view-order-overview';
            defaultNav = document.querySelector('.nav-menu .nav-item[data-target="' + defaultTarget + '"]');
            defaultView = document.getElementById(defaultTarget);
        }
        if (defaultNav) defaultNav.classList.add('active');
        if (defaultView) defaultView.classList.add('active');
    }


    navItems.forEach(item => {
        item.addEventListener("click", (e) => {
            e.preventDefault();
            const targetId = item.getAttribute("data-target");
            if (!targetId) return;

            // 清理 active 样式并切换视图
            navItems.forEach(nav => nav.classList.remove("active"));
            item.classList.add("active");

            views.forEach(view => view.classList.remove("active"));

            const targetView = document.getElementById(targetId);
            if (targetView) {
                // Lazy-load template before activating
                loadViewTemplate(targetId, function() {
                  targetView.classList.add("active");
                // 保存当前视图，刷新后自动恢复
                sessionStorage.setItem('efast_active_view', targetId);
                // 切换到订单总览时，从 localStorage 重新渲染订单（确保数据持久可见）
                if (targetId === 'view-order-overview') {
                    loadStoredSalesData();
                }
                // 切换到数据看板时，初始化
                if (targetId === 'view-dashboard') {
                    if (typeof Dashboard !== 'undefined') Dashboard.init();
                }
                if (targetId === 'view-invoice-builder' && typeof openInvoiceBuilder === 'function') openInvoiceBuilder();
                if (targetId === 'view-purchase-plan') {
                    if (typeof loadPurchasePlans === 'function') loadPurchasePlans();
                }
                if (targetId === 'view-performance') { if (typeof loadPerformanceDashboard === 'function') loadPerformanceDashboard(); }
                if (targetId === 'view-user-management') {
                    if (typeof initUserManagement === 'function') initUserManagement();
                }
                if (targetId === 'view-tool-nav') {
                    if (window.ToolNav && typeof window.ToolNav.init === 'function') window.ToolNav.init();
                }
                if (targetId === 'view-project-tracking') {
                    if (typeof ProjectTracking !== 'undefined') ProjectTracking.init();
                }
                if (targetId === 'view-product-center') {
                    if (typeof loadProducts === 'function') loadProducts();
                }
                if (targetId === 'view-customer-crm') {
                    if (typeof initCRM === 'function') initCRM();
                }
                if (targetId === 'view-organization' && Auth.getRole() === 'boss') {
                    if (typeof loadOrganizationData === 'function') loadOrganizationData();
                }
                if (targetId === 'view-system-settings') {
                    if (typeof loadCategoryFilter === 'function') loadCategoryFilter();
                    setupSettingsLazyLoad(targetView);
                }
                if (targetId === 'view-error-logs' && Auth.getRole() === 'boss') {
                    if (typeof loadErrorLogs === 'function') loadErrorLogs();
                }
                }); // end loadViewTemplate callback
            }
        });
    });

    // Trigger init for the currently active view on page load/refresh
}
/**
 * ==========================================
 * 2. 阿里国际站数据网关同步控制 (Alibaba Sync Gateway)
 * ==========================================
 */
let isSyncing = false;
let syncCompleted = false;
let __efastProgressInterval = null; // 加载进度提示定时器
var _pendingSyncSaves = [];

// 插件握手状态（由 postMessage 通道维护，而非跨沙箱 window 变量）
window._efastBridgeReady = false;

// 监听来自 workbench_bridge.js 的 postMessage 信号
window.addEventListener("message", (event) => {
    if (!event.data) return;

    // 握手信号：bridge 已就绪
    if (event.data.source === "efast_bridge_ready") {
        window._efastBridgeReady = true;
        console.log("[Efast Workbench] 插件握手成功！Bridge 已就绪。");
    }

    // 同步完成信号：bridge 写完数据，触发渲染
    if (event.data.source === "efast_sync_complete") {
        if (typeof onSyncComplete === "function") {
            onSyncComplete(event.data.orderCount || 0, event.data.scannedIds);
        }
    }
});

// 通知 Bridge 页面已就绪，触发双向握手
window.postMessage({ source: "efast_page_ready" }, "*");
console.log("[Efast Workbench] 页面就绪，向 Bridge 发送握手请求...");


// Handle URL page parameter (from Chrome extension or external links)
(function () {
  var params = new URLSearchParams(window.location.search);
  var page = params.get('page');
  if (page) {
    var targetId = page.indexOf('view-') === 0 ? page : 'view-' + page;
    sessionStorage.setItem('efast_active_view', targetId);
    var waContact = params.get('waContact');
    if (page && waContact) {
      sessionStorage.setItem('efast_wa_contact', waContact);
    }
    if (page) {
      setTimeout(function() {
        var nav = document.querySelector('.nav-menu .nav-item[data-target="' + targetId + '"]');
        if (nav) nav.click();
      }, 500);
    }
  }
})();